import { render, staticRenderFns } from "./EntityProperties.vue?vue&type=template&id=82f61432"
import script from "./EntityProperties.vue?vue&type=script&lang=js"
export * from "./EntityProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports